import { breakpointTablet } from "@gnist/design-system";

export const isMobile = () =>
  matchMedia(`(max-width: ${breakpointTablet})`).matches;
